import getStore from '../store/store';

export default function isFolderLoaded(folderId: string): boolean {
    return getStore().foldersInLoadingState.indexOf(folderId) == -1;
}
